import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
/**
 * KpiChart Body
 *
 * This component is in charge of displaying
 * the body of a kpi chart
 *
 * @param {string} children // children.
 * @param {string} className // className.
 *
 * @return {jsx}
 */

var KpiChartBody = function KpiChartBody(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-testid": "kpichart-body"
  }, children);
};
/**
 * PropTypes Validation
 */


var node = PropTypes.node,
    string = PropTypes.string;
KpiChartBody.propTypes = {
  children: node,
  className: string,
  // eslint-disable-next-line react/no-unused-prop-types
  height: string
};
/**
 * Default props
 */

KpiChartBody.defaultProps = {
  children: null,
  className: '',
  height: '37.3rem'
};
export default styled(KpiChartBody).withConfig({
  displayName: "Body",
  componentId: "sc-1i4x38k-0"
})(["height:", ";"], function (_ref2) {
  var height = _ref2.height;
  return /^\d+(rem|px)$/.test(height) ? height : '37.3rem';
});